import React,{Component} from 'react'
import styles from './index.module.scss'
import { observer,inject } from 'mobx-react'
@inject('tabBar')
@observer
class Toast extends Component {
    constructor(props) {
        super(props)
        this.state = {
            timer:null,
            isIpad:/ipad/i.test(navigator.userAgent.toLowerCase()),
        }
    };
    componentWillUpdate() {
        if(window.timer) clearInterval(window.timer)
        window.timer = setTimeout(() => {
            this.props.tabBar.changeTabShow(false);
        },2500)
    }
    render() {
        return (
            <div className={`${styles.toastBar} ${this.props.tabBar.toastShow ? styles.show : ''} ${this.state.isIpad ? styles.ipadStyle : ''}`}>
                {this.props.tabBar.contant}
            </div>
        )
    }
}
export default Toast;